import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProjectMapHelper from 'src/app/helpers/project-map-helper';
import Address from 'src/app/model/project/address';
import { LoadTask } from 'src/app/model/task-list/load-task';
import { SubProjectTask } from 'src/app/model/task-list/subproject-task';
import { Task, TASK_TYPES } from 'src/app/model/task-list/task';

export default class TaskAddressHelper {
  private constructor() {}

  public static getMapAddresses(tasks: Task[]): Address[] {
    if (!CollectionHelper.isPopulated(tasks)) {
      return [];
    }

    const waypoints: Address[] = [];

    for (const task of tasks) {
      if (task.type === TASK_TYPES.SUB_PROJECT_TASK) {
        waypoints.push(this.processSubProjectTask(<SubProjectTask>task));
      } else if (task.type === TASK_TYPES.LOAD_TASK) {
        const toPush = this.processLoadTask(<LoadTask>task, waypoints);
        if (toPush != null) {
          waypoints.push(toPush);
        }
      }
    }

    if (waypoints.length === 0) {
      return waypoints;
    }

    const start =
      waypoints[0] === ProjectMapHelper.INPRESS_ADDRESS
        ? null
        : ProjectMapHelper.INPRESS_ADDRESS;
    const end =
      waypoints[waypoints.length - 1] === ProjectMapHelper.INPRESS_ADDRESS
        ? null
        : ProjectMapHelper.INPRESS_ADDRESS;

    return [start, ...waypoints, end].filter(e => e != null);
  }

  private static processSubProjectTask(task: SubProjectTask): Address {
    return task.subProject.project.baseProjectAddress;
  }

  private static processLoadTask(
    task: LoadTask,
    waypoints: Address[]
  ): Address {
    return waypoints.length === 0 ||
      waypoints[waypoints.length - 1] === ProjectMapHelper.INPRESS_ADDRESS ||
      !task.active
      ? null
      : ProjectMapHelper.INPRESS_ADDRESS;
  }
}
